import React, { Component } from "react";

import {
  // ChevronLeftMinor, ChevronRightMinor, 
  MobileCancelMajor
} from '@shopify/polaris-icons';
import { Icon } from '@shopify/polaris';

//轮播图
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from "swiper";
import 'swiper/css'; // 公共引入轮播图样式
import 'swiper/css/bundle'; // 公共引入轮播图样式

import './index.css'
// import Language from '../../i18n/Language';
// const t = Language



class ImageShowDetail extends Component {
  state = {
    imageShowList: this.props.imageShowList,
    selImg: this.props.selImg
  }

  // 隐藏
  hideImageDetail = () => {
    this.props.hideImageDetailModal();
  }

  render() {
    const {
      state: {
        imageShowList,
        selImg,
      },
      hideImageDetail,
    } = this;
    return (
      <div className="image-show-detail" onClick={hideImageDetail}>
        <div className="image-show-close"><Icon source={MobileCancelMajor} /></div>
        <div className="image-show-main">
          <Swiper
            slidesPerView={"auto"}
            loop={false}
            autoplay={false}
            // navigation={{
            //   nextEl: '.swiper-button-next-n',
            //   prevEl: '.swiper-button-prev-p',
            // }}
            modules={[Autoplay, Pagination, Navigation]}
            pagination={{
              clickable: true,
            }}
            spaceBetween={10}
            initialSlide={Boolean(selImg) ? imageShowList.indexOf(selImg.split('?')[0]) : 0}
          >
            {imageShowList.map((item, index) => {
              return <SwiperSlide key={index}>
                <img className='showDetailImg' src={item} alt={item} />
              </SwiperSlide>
            })}
          </Swiper>
        </div>
        {/* <div className="swiper-button-next-p"><Icon
          source={ChevronLeftMinor}
          color="base"
        /></div>
        <div className="swiper-button-next-n"><Icon
          source={ChevronRightMinor}
          color="base"
        /></div> */}
      </div>
    );
  }
}

export default ImageShowDetail;